// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__fp9Kz","divider_span":"Divider_divider_span__6a7xZ"};